import { roleApi } from "@/core/apis";

// getter types
export const ROLES = "roles";

// action types
export const GET_ROLES = "getRoles";

// mutation types
const SET_ROLES = "setRoles";

const state = {
  roles: []
};

const getters = {
  [ROLES](state) {
    return state.roles;
  }
};

const actions = {
  [GET_ROLES](context) {
    return new Promise(resolve => {
      roleApi.getAllRolesData().then(response => {
        context.commit(SET_ROLES, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_ROLES](state, roles) {
    state.roles = roles;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
